import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';

import UserProfileDropdown from './Components/UserProfileDropdown';

import HSGLogo from './assets/logo-hsg.png';

import './HSGHeader.css';


class HSGHeader extends Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {

        }
    }

    componentDidMount() {}

    componentWillReceiveProps(newProps) {}

    componentWillUnmount() {}

    onClickLogout() {
        const cookies = this.props.cookies
        cookies.remove('token', {path: '/'})
        cookies.remove('roles', {path: '/'})

        this.props.logoutUser()
        window.location.reload(false)
    }

    showSidebar = () => {
        this.myRef.current.classList.toggle("change");
        if(this.props.sidebar) {
            this.props.unsetSidebarHandler(false)
        }
        else {
            this.props.setSidebarHandler(true)
        }
    }

    render() {

        const { userProfile } = this.props

        return (
            <div ref="header" className="hsg-header-main-root">
                <div className="container-fluid hamburger-container">
                    <div className="col-sm-6 hidden-xs hidden-sm hsg-hide-logo">
                        <div className="">
                            <img className="hsg-header-logo" alt="Health Set Go" src={HSGLogo} />
                        </div>
                    </div>
                    <div className = "col-sm-6 hamburger">
                       <div className = "hamburger__Container" ref={this.myRef} onClick = {this.showSidebar}>
                            <div className="bar1"></div>
                            <div className="bar2"></div>
                            <div className="bar3"></div>
                       </div>
                        {/* <i class="fas fa-bars fa-2x hamburger" onClick = {() => this.props.setSidebarHandler(true)}></i> */}
                    </div>
                    <div className="col-sm-6 col-xs-12 hsg-header-main-right">
                        <div className="hsg-header-main-vertical-line  hidden-xs" />
                        <div className="hsg-header-main-profile">
                            <UserProfileDropdown 
                                name={`${userProfile.fullName}`}
                                profilePic={userProfile.profilePic}
                                childList={this.props.childList}
                                childCurrent={this.props.childCurrent}

                                onClickLogout={() => this.onClickLogout()}
                                onClickProfile={() => this.props.showModalUserProfile()}
                                updateSelectedChild={(index) => this.props.updateSelectedChild(index)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



export default withCookies(HSGHeader)


HSGHeader.propTypes = {
    heading: PropTypes.string.isRequired,
    setHeaderElement: PropTypes.func
}

HSGHeader.defaultProps = {
    heading: "HEALTH SET GO"
}